var map = {
	"./a.svg": 162,
	"./b.svg": 163,
	"./be_back.svg": 139,
	"./bravo.svg": 151,
	"./c.svg": 164,
	"./clean.svg": 122,
	"./coffee.svg": 138,
	"./d.svg": 165,
	"./e.svg": 166,
	"./eight.svg": 156,
	"./elmo.svg": 140,
	"./exposed.svg": 123,
	"./feedback.svg": 141,
	"./five.svg": 87,
	"./forty.svg": 159,
	"./four.svg": 118,
	"./half.svg": 155,
	"./heart.svg": 150,
	"./hundred.svg": 160,
	"./incognito.svg": 89,
	"./leave.svg": 142,
	"./lol.svg": 153,
	"./mute.svg": 143,
	"./no.svg": 144,
	"./no_audio.svg": 146,
	"./no_screen.svg": 147,
	"./one.svg": 84,
	"./party.svg": 152,
	"./pattern2.svg": 522,
	"./question.svg": 161,
	"./send.svg": 124,
	"./thirteen.svg": 157,
	"./three.svg": 86,
	"./timeup.svg": 148,
	"./twenty.svg": 158,
	"./two.svg": 85,
	"./voting.svg": 90,
	"./webcam.svg": 149,
	"./yes.svg": 145,
	"./zero.svg": 154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68;